"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarWrapper = exports.SidebarContentWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var SidebarWrapper = exports.SidebarWrapper = (0, _styledComponents["default"])(_reactstrap.Row)(function (_ref) {
  var $isChat = _ref.$isChat,
    $maxWidth = _ref.$maxWidth,
    $minHeight = _ref.$minHeight;
  return "\n  max-width: ".concat($maxWidth, ";\n  min-height: ").concat($minHeight, ";\n  background: #282a39;\n  box-shadow: ").concat(!$isChat ? 'inset 4px 0px 8px #0a0b10' : 'none', ";\n  margin: 0;\n  width: 100%;\n  flex-wrap: nowrap;\n  border-left: 1px solid #333649;\n  position: fixed;\n\n  & > * {\n    flex-shrink: unset;\n    padding-right: unset;\n    padding-left: unset;\n    max-width: unset;\n    margin-top: unset;\n  }\n");
});
var SidebarContentWrapper = exports.SidebarContentWrapper = _styledComponents["default"].div(function (_ref2) {
  var $isChat = _ref2.$isChat;
  return "\n  flex-grow: 1;\n  padding: ".concat(!$isChat ? '16px' : '0', ";\n");
});